import React from 'react';
import bgImage from '../assets/images/bg.png';
const Header = () => {
  return (
    <div
      className="relative bg-cover bg-center h-64 flex items-center justify-center"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="text-center px-4">
        <p className="mt-2 text-white">
          Dive deep into raw emotion and soulful melodies. <br />
          "Heartfelt" — the album that speaks straight to your soul.
        </p>
        <button className="mt-4 px-4 py-2 bg-white rounded hover:bg-white transition text-black">
          Create Now
        </button>
      </div>
    </div>
  );
};

export default Header;
